import { z } from 'zod';

export type FindMyOrderEventType = 'FindMyOrder_Search_Start'
  | 'FindMyOrder_Search_Success'
  | 'FindMyOrder_Search_Fail'
  | 'FindMyOrder_ViewInvoice'
  | 'FindMyOrder_ViewProduct'
  | 'FindMyOrder_CancelRebilling'
  | 'FindMyOrder_ChangePayment'
  | 'FindMyOrder_RequestRefund';

// FindMyOrder event payload schemas
export const FindMyOrderSearchStartPayloadSchema = z.object({
  searchType: z.string(),
  usedField: z.string(),
  locale: z.string(),
  is_cancellation: z.boolean().optional(),
});

export const FindMyOrderSearchSuccessPayloadSchema = z.object({
  searchType: z.string(),
  locale: z.string(),
  is_cancellation: z.boolean().optional(),
  purchase: z.object({
    // order_id: z.string(), // GDPR: Temporarily removed for privacy compliance
    reseller: z.string().optional(),
    product_type: z.string().optional(),
    billing_type: z.string().optional(),
  }),
});

export const FindMyOrderSearchFailPayloadSchema = z.object({
  searchType: z.string(),
  locale: z.string(),
  is_cancellation: z.boolean().optional(),
});

export const FindMyOrderActionPayloadSchema = z.object({
  // order_id: z.string(), // GDPR: Temporarily removed for privacy compliance
  locale: z.string(),
  reseller: z.string().optional(),
  product_type: z.string().optional(),
  billing_type: z.string().optional(),
});

export type FindMyOrderEventTypePayloadMap = {
  FindMyOrder_Search_Start: z.infer<typeof FindMyOrderSearchStartPayloadSchema>;
  FindMyOrder_Search_Success: z.infer<typeof FindMyOrderSearchSuccessPayloadSchema>;
  FindMyOrder_Search_Fail: z.infer<typeof FindMyOrderSearchFailPayloadSchema>;
  FindMyOrder_ViewInvoice: z.infer<typeof FindMyOrderActionPayloadSchema>;
  FindMyOrder_ViewProduct: z.infer<typeof FindMyOrderActionPayloadSchema>;
  FindMyOrder_CancelRebilling: z.infer<typeof FindMyOrderActionPayloadSchema>;
  FindMyOrder_ChangePayment: z.infer<typeof FindMyOrderActionPayloadSchema>;
  FindMyOrder_RequestRefund: z.infer<typeof FindMyOrderActionPayloadSchema>;
};

export const FindMyOrderEventSchemaMap = {
  FindMyOrder_Search_Start: FindMyOrderSearchStartPayloadSchema,
  FindMyOrder_Search_Success: FindMyOrderSearchSuccessPayloadSchema,
  FindMyOrder_Search_Fail: FindMyOrderSearchFailPayloadSchema,
  FindMyOrder_ViewInvoice: FindMyOrderActionPayloadSchema,
  FindMyOrder_ViewProduct: FindMyOrderActionPayloadSchema,
  FindMyOrder_CancelRebilling: FindMyOrderActionPayloadSchema,
  FindMyOrder_ChangePayment: FindMyOrderActionPayloadSchema,
  FindMyOrder_RequestRefund: FindMyOrderActionPayloadSchema,
};